export interface Notification {
    id: string;
    created_at: string;
    title: string;
    body: string;
    is_read: boolean;
    type: string;
    translate_in_frontend: boolean;
    title_params: Record<string, string>;
    body_params: Record<string, string>;
}

export interface NotificationCreate {
    title: string;
    body: string;
    is_read: boolean;
    type: NotificationType;
    translate_in_frontend: boolean;
    title_params: Record<string, string>;
    body_params: Record<string, string>;
}

export enum NotificationType {
    ALERT = "ALERT",
    MESSAGE = "MESSAGE"
}

export enum NotificationResponseType {
    INITIAL = "INITIAL",
    MESSAGE = "MESSAGE",
    NEXT_PAGE = "NEXT_PAGE"
}

export interface NotificationWSResponse {
    type: NotificationResponseType;
    total_content_length: number;
    unread_notifications: number | null;
    content: Notification | Notification[];
}

export enum NotificationMessageType {
    PING = "PING",
    IS_READ_STATUS_UPDATE = "IS_READ_STATUS_UPDATE",
    GET_PAGE = "GET_PAGE"
}

export interface PingContent {
}

export interface IsReadStatusUpdateContent {
    id: string;
    is_read: boolean;
}

export interface GetPageContent {
    new_page: number;
    per_page: number;
}

export interface NotificationWSMessage {
    type: NotificationMessageType;
    content: PingContent | IsReadStatusUpdateContent | GetPageContent;
}